import {z as r} from 'zod';

import {ShortLocaleNameEnum} from '../../provider/locale/locale-context-type';

export enum FeaturesEnum {
    photoTool = 'phototool',
    photoToolPro = 'phototool_pro',
    reviewAnalyticsBase = 'review_analytics_base',
    reviewAnalyticsFull = 'review_analytics_full',
    reviewAnalyticsCompetitor = 'review_analytics_competitor',
    // BST-10541 «Аспекты 2.0» client access. Backend must define/grant this licence
    // (MSB-4122); until then the value stays absent and the feature is off for clients.
    reviewAnalyticsAspects = 'aspect_analysis',
    duplicatesAndFakes = 'duplicates_and_fakes', // hide from navigation menu and routing if feature enabled
    posts = 'posts',
    reviewsGenerator = 'reviews_generator',
    reviewSuggests = 'review_suggests',
    storeLocator = 'store_locator',
    onlinePresenceAnalytics = 'online_presence_analytics',
    dashboard = 'dashboard',
    localPack = 'local_pack',
    companyGroups = 'company_groups',
    usedeskIntegration = 'usedesk_integration',
    prices = 'prices',
    analytics = 'analytics',
    userManagement = 'user_management',
    chatwoot = 'chatwoot',
    publicApi = 'public_api',
    reviewGptReplySuggestions = 'review_gpt_reply_suggestions',
    gptAutoReplyLicence = 'gpt_auto_reply_licence',
    mailingListLicence = 'mailing_list_licence',
    tariffs = 'tariffs',
    companiesExport = 'companies_export',
    knowledge = 'knowledge',
    neuralNetwork = 'neural_network',
    reviews = 'reviews',
    settings = 'settings',
    questionsAndAnswers = 'questions_and_answers',
    sources = 'sources',
    myCompanies = 'my_companies',
    integrations = 'integrations',
    notification = 'notification',
    bulkGenerateButton = 'bulk_generate_button',
    sourceGroupReviewsEmployers = 'source_group_reviews_employers',
    internalAgencyReviewCatalogsLicense = 'internal_agency_review_catalogs_license',
    internalAgencyPostsLicense = 'internal_agency_posts_license',
    internalAgencyReviewCatalogsInfoLicense = 'internal_agency_review_catalogs_info_licence',
    internalAgencyIrrelevantReviewsAbuseLicense = 'internal_agency_irrelevant_reviews_abuse_licence',
    internalAgencyReviewsGeneratorMailingLaunchLicense = 'internal_agency_reviews_generator_mailing_launch_licence',
    internalAgencyReviewsLicense = 'internal_agency_reviews_license',
    internalAgencyQrCodesLicense = 'internal_agency_qr_codes_license',
    internalAgencyStorelocatorLicense = 'internal_agency_storelocator_license',
    internalAgencyPhotoLicence = 'internal_agency_photo_licence',
    internalAgencyPricesLicense = 'internal_agency_prices_license',
    internalAgencyYandexPhotosManagementLicense = 'internal_agency_yandex_photos_management_licence',
    internalAgencyStoriesLicense = 'internal_agency_stories_license',
    internalAgencyCabinetInfoLicense = 'internal_agency_cabinet_info_licence',
    mlReplies = 'ml_replies',
    internalAgencyFakesAndDuplicatesLicense = 'internal_agency_fakes_and_duplicates_licence',
    internalAgencyCustomReportsLicense = 'internal_agency_custom_reports_licence',
    internalAgencyOuterReviewsLicense = 'internal_agency_outer_reviews_licence',
    yandexStories = 'yandex_stories',
    reviewsWidget = 'reviews_widget',
    aiBrandMonitoring = 'ai_brand_monitoring',
}

const userProfileSchema = r.object({
    firstName: r.string(),
    isShowAutotags: r.boolean(),
    timezone: r.string(),
});

export const lastRoutePathSchema = r.string();

export const userSchema = r.object({
    id: r.number(),
    email: r.string(),
    language: r.nativeEnum(ShortLocaleNameEnum),
    isStaff: r.boolean(),
    isDoubleGisUser: r.boolean(),
    isDoubleGisTrusted: r.boolean(),
    isTestUser: r.boolean(),
    isDemoCpUser: r.boolean(),
    is2faEnabled: r.boolean(),
    isInternalAgency: r.boolean(),
    profile: userProfileSchema,
    favoriteSections: r.array(r.string()),
    regionAvailableCatalogs: r.record(r.boolean()),
});

export type UserType = r.infer<typeof userSchema>;
